import React from 'react';

import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useSelector } from 'react-redux';

import { currentAccountSelector, userSelector } from 'store/user/selectors';

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY!;

const isNonProduction = process.env.NODE_ENV !== 'production';

export const withPostHog = function <T extends {}>(Component: React.ComponentType<T>) {
  if (isNonProduction) return (props: T & React.PropsWithChildren<{}>) => <Component {...props} />;

  return function (props: T & React.PropsWithChildren<{}>) {
    const user = useSelector(userSelector);
    const account = useSelector(currentAccountSelector);

    React.useEffect(() => {
      posthog.init(posthogKey, {
        api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        person_profiles: 'identified_only',
      });

      posthog.startSessionRecording();

      return () => {
        posthog.reset();
        posthog.stopSessionRecording();
      };
    }, []);

    React.useEffect(() => {
      if (user) {
        const username = `${user.email}/${account?.id}`;
        posthog.identify(username, { email: user.email, account_id: account?.id, username });
      } else {
        posthog.reset();
      }
    }, [user, account]);

    return (
      <PostHogProvider client={posthog}>
        <Component {...props} />
      </PostHogProvider>
    );
  };
};
